import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import CONFIG from "../../config";
import "./ActualizarMemoria.css";

export default function ActualizarMemoria({ onBack }) {
  const [memorias, setMemorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({ id: null, tema: "", informacion: "" });

  const URL_ACTUALIZAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Actualizar-memoria-LaPile";
  const URL_ANEXAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Nueva-memoria-LaPile";
  const URL_ELIMINAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Eliminar-memoria-LaPile";

  const cargarMemoria = () => {
    axios
      .get(`${CONFIG.API_URL}memoria.php`, { withCredentials: true })
      .then((res) => {
        if (res.data.ok) {
          setMemorias(res.data.data || []);
        }
      })
      .catch((error) => {
        Swal.fire("Error", "No se pudo cargar la memoria", "error");
        console.error("Error al cargar memoria");
        console.error("Respuesta del servidor:", error.response?.data || error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    cargarMemoria();
  }, []);

  const abrir = (memoria) => {
    setForm({
      id: memoria.id ?? null,
      tema: memoria.tema ?? "",
      informacion: memoria.informacion ?? "",
    });
    setModal(true);
    setEditando(false);
  };

  const cerrar = () => setModal(false);

  // Función mejorada (más segura y con headers)
  const enviarAN8N = async (url, payload) => {
    try {
      await fetch(url, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error("Error enviando a n8n:", error);
    }
  };

  const guardar = () => {
    if (!form.tema.trim() || !form.informacion.trim()) {
      Swal.fire("Error", "Completa todos los campos", "warning");
      return;
    }

    const esEdicion = !!form.id;

    Swal.fire({
      title: esEdicion ? "¿Actualizar memoria?" : "¿Guardar memoria?",
      text: esEdicion
        ? "Se actualizará la base de datos y se enviará a n8n."
        : "Se guardará la memoria nueva y se enviará a n8n.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: esEdicion ? "Sí, actualizar" : "Sí, guardar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      cerrar();

      axios
        .post(`${CONFIG.API_URL}memoria.php`, form, { withCredentials: true })
        .then((res) => {
          if (!res.data.ok) {
            throw new Error(res.data.message || "Error al guardar");
          }

          const payload = {
            id: res.data.data?.id ?? form.id,
            tema: form.tema,
            informacion: form.informacion,
            accion: esEdicion ? "actualizar" : "anexar",
          };

          const urlN8N = esEdicion ? URL_ACTUALIZAR : URL_ANEXAR;

          return enviarAN8N(urlN8N, payload).then(() => {
            Swal.fire(
              "Listo",
              esEdicion ? "Memoria actualizada y enviada" : "Memoria agregada y enviada",
              "success"
            );
            cargarMemoria();
            setEditando(false);
          });
        })
        .catch((err) => {
          Swal.fire("Error", err.message || "Error al guardar", "error");
        });
    });
  };

  // ← FUNCIÓN ELIMINAR ACTUALIZADA (ahora envía id + tema + informacion)
  const eliminar = (id) => {
    // Buscamos la memoria completa para obtener tema e información
    const memoriaAEliminar = memorias.find((m) => m.id === id);

    if (!memoriaAEliminar) {
      Swal.fire("Error", "No se encontró la memoria", "error");
      return;
    }

    Swal.fire({
      title: "¿Eliminar memoria?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      cerrar();

      axios
        .delete(`${CONFIG.API_URL}memoria.php`, { data: { id }, withCredentials: true })
        .then((res) => {
          if (!res.data.ok) {
            throw new Error(res.data.message || "No se pudo eliminar");
          }

          // Payload completo que se envía a n8n
          const payload = {
            id: memoriaAEliminar.id,
            tema: memoriaAEliminar.tema,
            informacion: memoriaAEliminar.informacion,
            accion: "eliminar",
          };

          return enviarAN8N(URL_ELIMINAR, payload).then(() => {
            Swal.fire(
              "Eliminado",
              "La memoria fue eliminada y sincronizada con n8n",
              "success"
            );
            cargarMemoria();
          });
        })
        .catch((err) => {
          Swal.fire("Error", err.message || "No se pudo eliminar", "error");
        });
    });
  };

  const nuevaMemoria = () => {
    setForm({ id: null, tema: "", informacion: "" });
    setModal(true);
    setEditando(true);
  };

  return (
    <div className="memoria-container">
      <div className="memoria-header">
        <button className="back-btn" onClick={onBack}>
          ← Volver
        </button>
        <h2>🧠 Memoria del chatbot</h2>
        <button className="new-btn" onClick={nuevaMemoria}>
          + Nueva memoria
        </button>
      </div>

      {loading ? (
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando memorias...</p>
        </div>
      ) : (
        <div className="memoria-grid">
          {memorias.map((m) => (
            <div key={m.id} className="memory-card" onClick={() => abrir(m)}>
              <h3>{m.tema}</h3>
              <p>{(m.informacion || "").slice(0, 100)}...</p>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={cerrar}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={cerrar}>
              ✕
            </button>
            <h3>{form.id ? "✏️ Editar memoria" : "📝 Nueva memoria"}</h3>

            <input
              type="text"
              placeholder="Tema"
              value={form.tema}
              onChange={(e) => setForm({ ...form, tema: e.target.value })}
            />
            <textarea
              placeholder="Información detallada..."
              value={form.informacion}
              onChange={(e) => setForm({ ...form, informacion: e.target.value })}
              rows={5}
            />

            <div className="modal-actions">
              <button className="save-btn" onClick={guardar}>
                Guardar
              </button>
              {form.id && (
                <button
                  className="delete-btn"
                  onClick={() => eliminar(form.id)}
                >
                  Eliminar
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}